// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Catalogue_container__JrNJF {
  width: 100%;
  height: 100%;
}
.Catalogue_container_heading__jlOxk {
  display: flex;
  align-items: center;
  padding-inline: 4rem;
  gap: 2rem;
  width: 100%;
  height: 7rem;
  background-color: var(--color-primary-5);
}
.Catalogue_container_heading__shape__24mmg {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--default-font-h2);
  font-weight: 700;
  background-color: var(--color-white);
  width: 5rem;
  height: 5rem;
  border-radius: 9rem;
}

.Catalogue_breadCrumbs__c7Z4N {
  background-color: var(--color-primary);
  width: 1rem;
  height: 1rem;
  border-radius: 5px;
  z-index: 100;
  cursor: pointer;
}

.Catalogue_inActive__SV2JE {
  background-color: var(--color-primary-8);
  width: 1rem;
  height: 1rem;
  border-radius: 5px;
  z-index: 100;
  cursor: pointer;
}

.Catalogue_breadCrumbsBox__F7V3S {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.Catalogue_imageContainer__dQ7yK {
  display: flex;
  height: 80rem;
  justify-content: center;
  margin-top: 2rem;
}

.Catalogue_smallImages__kBUTJ {
  display: flex;
  flex-direction: column;
  height: 70rem;
  gap: 2rem;
  padding: 0 2rem;
}

.Catalogue_smallImage__Kfayp {
  width: 15rem;
  height: 17rem;
  cursor: pointer;
}

.Catalogue_largeImageContainer__GURF9 {
  width: 50rem;
  height: 70rem;
}

.Catalogue_largeImage__-bT91 {
  width: 100%;
  height: 70rem;
  cursor: pointer;
}

.Catalogue_selectedSmallImage__yXaBO {
  border: 2px solid blue;
}

.Catalogue_selectedLargeImage__cBU\\+7 {
  border: 2px solid red;
}

.Catalogue_section__riptd {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 2rem;
  padding: 4rem;
}
@media only screen and (max-width: 50em) {
  .Catalogue_section__riptd {
    grid-template-columns: 1fr;
  }
}
.Catalogue_section_form__8YV42 {
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 10rem;
}
@media only screen and (max-width: 50em) {
  .Catalogue_section_form__8YV42 {
    margin-top: 0;
  }
}

.Catalogue_line__P\\+mlY {
  width: 100%;
  margin: 2rem 0;
  border: solid 1px;
}

.Catalogue_btn__ENN2Y {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  margin: 4rem 0;
}

/* Pagination.css */
.Catalogue_pagination__soD-m {
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 4rem;
}

.Catalogue_pagination__soD-m li {
  margin: 0 5px;
  cursor: pointer;
  border: 1px solid #ccc;
  padding: 5px 10px;
}

.Catalogue_pagination__soD-m li.Catalogue_active__zc7Hz {
  font-weight: bold;
  color: blue;
  background-color: #f0f0f0;
}

.Catalogue_dtl__CqjzB {
  display: flex;
  justify-content: space-between;
  width: 38rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Catalogue/Catalogue.module.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,YAAA;AADD;AAIC;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;AAFF;AAIE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAFH;;AAOA;EACC,sCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAJD;;AAOA;EACC,wCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAJD;;AAOA;EACC,gBAAA;EACC,aAAA;EACA,uBAAA;EACA,SAAA;AAJF;;AASC;EACC,aAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AANF;;AASG;EACD,aAAA;EACA,sBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;AANF;;AASG;EACD,YAAA;EACA,aAAA;EACA,eAAA;AANF;;AASG;EACD,YAAA;EACA,aAAA;AANF;;AASG;EACD,WAAA;EACA,aAAA;EACA,eAAA;AANF;;AASG;EACD,sBAAA;AANF;;AASG;EACD,qBAAA;AANF;;AASG;EACD,aAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;AANF;AAQE;EAPC;IAQA,0BAAA;EALD;AACF;AAOE;EACC,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;AALH;AAMG;EALD;IAME,aAAA;EAHF;AACF;;AAMG;EACD,WAAA;EACA,cAAA;EACA,iBAAA;AAHF;;AAMG;EACD,aAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;AAHF;;AAKA,mBAAA;AAEA;EACC,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;AAHD;;AAME;EACD,aAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAHD;;AAME;EACD,iBAAA;EACA,WAAA;EACA,yBAAA;AAHD;;AAME;EACD,aAAA;EACA,8BAAA;EACA,YAAA;AAHD","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n\twidth: 100%;\n\theight: 100%;\n\t\n\n\t&_heading {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding-inline: 4rem;\n\t\tgap: 2rem;\n\t\twidth: 100%;\n\t\theight: 7rem;\n\t\tbackground-color: var(--color-primary-5);\n\n\t\t&__shape {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tfont-size: var(--default-font-h2);\n\t\t\tfont-weight: 700;\n\t\t\tbackground-color: var(--color-white);\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\tborder-radius: 9rem;\n\t\t}\n\t}\n}\n\n.breadCrumbs {\n\tbackground-color: var(--color-primary);\n\twidth: 1rem;\n\theight: 1rem;\n\tborder-radius: 5px;\n\tz-index: 100;\n\tcursor: pointer;\n}\n\n.inActive {\n\tbackground-color: var(--color-primary-8);\n\twidth: 1rem;\n\theight: 1rem;\n\tborder-radius: 5px;\n\tz-index: 100;\n\tcursor: pointer;\n\t}\n\n.breadCrumbsBox {\n\tmargin-top: 2rem;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tgap: 1rem;\n}\n\n\n\n\t.imageContainer {\n\t\tdisplay: flex;\n\t\theight: 80rem;\n\t\tjustify-content: center;\n\t\tmargin-top: 2rem;\n\t  }\n\n\t  .smallImages {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\theight: 70rem;\n\t\tgap: 2rem;\n\t\tpadding: 0 2rem;\n\t  }\n\n\t  .smallImage {\n\t\twidth: 15rem;\n\t\theight: 17rem;\n\t\tcursor: pointer;\n\t  }\n\n\t  .largeImageContainer {\n\t\twidth: 50rem;\n\t\theight: 70rem;\n\t  }\n\n\t  .largeImage {\n\t\twidth: 100%;\n\t\theight: 70rem;\n\t\tcursor: pointer;\n\t  }\n\n\t  .selectedSmallImage {\n\t\tborder: 2px solid blue;\n\t  }\n\n\t  .selectedLargeImage {\n\t\tborder: 2px solid red;\n\t  }\n\n\t  .section {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 1fr;\n\t\twidth: 100%;\n\t\tgap: 2rem;\n\t\tpadding: 4rem;\n\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\tgrid-template-columns: 1fr;\n\t\t  }\n\n\t\t&_form {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\ttext-align: center;\n\t\t\tmargin-top: 10rem;\n\t\t\t@media only screen and (max-width: $bp-800) {\n\t\t\t\tmargin-top: 0;\n\t\t\t  }\n\t\t}\n\t  }\n\t  .line {\n\t\twidth: 100%;\n\t\tmargin: 2rem 0;\n\t\tborder: solid 1px;\n\t  }\n\n\t  .btn {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tgap: 2rem;\n\t\tmargin: 4rem 0;\n\t  }\n/* Pagination.css */\n\n.pagination {\n\tdisplay: flex;\n\tjustify-content: center;\n\tlist-style: none;\n\tpadding: 4rem;\n  }\n  \n  .pagination li {\n\tmargin: 0 5px;\n\tcursor: pointer;\n\tborder: 1px solid #ccc; \n\tpadding: 5px 10px; \n  }\n  \n  .pagination li.active {\n\tfont-weight: bold;\n\tcolor: blue; \n\tbackground-color: #f0f0f0; \n  }\n  \n  .dtl {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 38rem;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Catalogue_container__JrNJF`,
	"container_heading": `Catalogue_container_heading__jlOxk`,
	"container_heading__shape": `Catalogue_container_heading__shape__24mmg`,
	"breadCrumbs": `Catalogue_breadCrumbs__c7Z4N`,
	"inActive": `Catalogue_inActive__SV2JE`,
	"breadCrumbsBox": `Catalogue_breadCrumbsBox__F7V3S`,
	"imageContainer": `Catalogue_imageContainer__dQ7yK`,
	"smallImages": `Catalogue_smallImages__kBUTJ`,
	"smallImage": `Catalogue_smallImage__Kfayp`,
	"largeImageContainer": `Catalogue_largeImageContainer__GURF9`,
	"largeImage": `Catalogue_largeImage__-bT91`,
	"selectedSmallImage": `Catalogue_selectedSmallImage__yXaBO`,
	"selectedLargeImage": `Catalogue_selectedLargeImage__cBU+7`,
	"section": `Catalogue_section__riptd`,
	"section_form": `Catalogue_section_form__8YV42`,
	"line": `Catalogue_line__P+mlY`,
	"btn": `Catalogue_btn__ENN2Y`,
	"pagination": `Catalogue_pagination__soD-m`,
	"active": `Catalogue_active__zc7Hz`,
	"dtl": `Catalogue_dtl__CqjzB`
};
export default ___CSS_LOADER_EXPORT___;
